module.exports = __webpack_public_path__ + "static/img/NTFusion_logo.2752734.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/NTFusion_logo.png
// module id = ww4H
// module chunks = 7